<template>
    <div>
        <form @submit.prevent="saveSettings">
            <div class="form-group">
                <label>
                    <input type="checkbox" v-model="form.is_active" :value="1" :unchecked-value="0" />
                    Aktifkan Follow Up Otomatis
                </label>
            </div>

            <div class="form-group">
                <label>Zona Waktu</label>
                <select v-model.number="form.timezone" class="form-control">
                    <option :value="-12">UTC-12</option>
                    <option :value="-11">UTC-11</option>
                    <option :value="-10">UTC-10</option>
                    <option :value="-9">UTC-9</option>
                    <option :value="-8">UTC-8</option>
                    <option :value="-7">UTC-7</option>
                    <option :value="-6">UTC-6</option>
                    <option :value="-5">UTC-5</option>
                    <option :value="-4">UTC-4</option>
                    <option :value="-3">UTC-3</option>
                    <option :value="-2">UTC-2</option>
                    <option :value="-1">UTC-1</option>
                    <option :value="0">UTC+0</option>
                    <option :value="1">UTC+1</option>
                    <option :value="2">UTC+2</option>
                    <option :value="3">UTC+3</option>
                    <option :value="4">UTC+4</option>
                    <option :value="5">UTC+5</option>
                    <option :value="6">UTC+6</option>
                    <option :value="7">UTC+7 (WIB)</option>
                    <option :value="8">UTC+8 (WITA)</option>
                    <option :value="9">UTC+9 (WIT)</option>
                    <option :value="10">UTC+10</option>
                    <option :value="11">UTC+11</option>
                    <option :value="12">UTC+12</option>
                </select>
            </div>

            <div class="form-group">
                <label>Jam Kerja Mulai</label>
                <div class="d-flex align-items-center flex-wrap" style="gap: 8px;">
                    <input type="time" v-model="form.work_hours_start" class="form-control" style="max-width: 200px;" />
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="clearWorkHour('start')" :disabled="!form.work_hours_start">
                        <i class="fas fa-times"></i> Kosongkan
                    </button>
                </div>
                <small class="form-text text-muted">
                    <i class="fas fa-info-circle"></i>
                    Pesan follow up hanya dikirim mulai jam ini. Kosongkan = kirim 24 jam.
                </small>
            </div>

            <div class="form-group">
                <label>Jam Kerja Selesai</label>
                <div class="d-flex align-items-center flex-wrap" style="gap: 8px;">
                    <input type="time" v-model="form.work_hours_end" class="form-control" style="max-width: 200px;" />
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="clearWorkHour('end')" :disabled="!form.work_hours_end">
                        <i class="fas fa-times"></i> Kosongkan
                    </button>
                    <button type="button" class="btn btn-outline-danger btn-sm" @click="clearAllWorkHours" :disabled="!form.work_hours_start && !form.work_hours_end">
                        <i class="fas fa-eraser"></i> Hapus Semua Jam Kerja
                    </button>
                </div>
                <small class="form-text text-muted">
                    <i class="fas fa-info-circle"></i>
                    Pesan follow up berhenti setelah jam ini. Kosongkan = kirim 24 jam.
                </small>
            </div>

            <div class="form-group">
                <label>Hari Kerja</label>
                <div class="d-flex flex-wrap" style="gap: 12px;">
                    <label v-for="day in dayOptions" :key="day.value" class="mb-0" style="font-weight: normal;">
                        <input type="checkbox" :value="day.value" v-model="selectedDays" /> {{ day.label }}
                    </label>
                </div>
                <small class="form-text text-muted">
                    <i class="fas fa-info-circle"></i>
                    Pilih hari-hari mana saja yang pesan follow up boleh dikirim. Jika tidak ada yang dipilih = kirim semua hari.
                </small>
            </div>

            <div class="form-group">
                <label>Maksimal Follow Up Per Kontak</label>
                <input type="number" v-model.number="form.max_follow_up_per_contact" class="form-control" min="0" />
                <small class="form-text text-muted">
                    <i class="fas fa-info-circle"></i>
                    Maksimal jumlah flow berbeda yang bisa dijalankan ke 1 kontak yang sama. Isi <code>0</code> untuk tanpa batas.
                </small>
            </div>

            <div class="form-group">
                <label>Jeda Minimum Antar Step (menit)</label>
                <input type="number" v-model.number="form.min_delay_between_steps" class="form-control" min="0" />
                <small class="form-text text-muted">
                    <i class="fas fa-info-circle"></i>
                    Jika delay step di bawah nilai ini, akan di-override. Isi <code>0</code> untuk mengikuti delay per-step apa adanya.
                </small>
            </div>

            <div class="form-group">
                <label>Device Pengiriman <span class="text-danger">*</span></label>
                <multiselect
                    v-model="form.device_ids"
                    :options="devices"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Pilih device"
                    label="name"
                    track-by="id"
                    :custom-label="customLabel"
                    :loading="isLoadingDevices"
                ></multiselect>
                <small class="form-text text-muted">Pilih satu atau lebih device untuk mengirim follow up</small>
            </div>

            <button type="submit" class="btn btn-primary" :disabled="isSaving">
                <i class="fas fa-save"></i> {{ isSaving ? 'Menyimpan...' : 'Simpan Pengaturan' }}
            </button>
        </form>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    components: {
        Multiselect
    },
    data() {
        return {
            form: {
                is_active: 0,
                timezone: 7,
                work_hours_start: null,
                work_hours_end: null,
                work_days: null,
                max_follow_up_per_contact: 5,
                min_delay_between_steps: 60,
                device_ids: []
            },
            selectedDays: [], // array of day numbers 0-6
            dayOptions: [
                { value: 1, label: 'Senin' },
                { value: 2, label: 'Selasa' },
                { value: 3, label: 'Rabu' },
                { value: 4, label: 'Kamis' },
                { value: 5, label: 'Jumat' },
                { value: 6, label: 'Sabtu' },
                { value: 0, label: 'Minggu' }
            ],
            devices: [],
            isLoadingDevices: false,
            isSaving: false
        };
    },
    async mounted() {
        await this.loadDevices();
        // Load settings after devices are loaded so we can map device IDs
        await this.loadSettings();
    },
    methods: {
        async loadDevices() {
            this.isLoadingDevices = true;
            try {
                let response = await this.$store.dispatch("device_list_all");
                this.devices = (response.data.data.devices || []).map(device => ({
                    id: device.id,
                    name: device.name,
                    device_id: device.device_id,
                    status: device.status
                }))
            } catch (err) {
                this.$toast.error("Gagal memuat device");
                console.error(err);
            } finally {
                this.isLoadingDevices = false;
            }
        },
        async loadSettings() {
            try {
                const response = await this.$store.dispatch("followup/followup_settings_get");
                const setting = response.data.data.setting;
                if (setting) {
                    this.form.is_active = setting.is_active === true || setting.is_active === 1 ? 1 : 0;
                    this.form.timezone = setting.timezone || 7;
                    this.form.work_hours_start = setting.work_hours_start;
                    this.form.work_hours_end = setting.work_hours_end;
                    this.form.work_days = setting.work_days;
                    // Parse work_days string "0,1,2,3,4,5,6" into selectedDays array
                    if (setting.work_days && typeof setting.work_days === 'string') {
                        this.selectedDays = setting.work_days.split(',')
                            .map(s => parseInt(s.trim(), 10))
                            .filter(n => !isNaN(n) && n >= 0 && n <= 6);
                    } else {
                        this.selectedDays = [];
                    }
                    this.form.max_follow_up_per_contact = setting.max_follow_up_per_contact || 5;
                    this.form.min_delay_between_steps = setting.min_delay_between_steps != null ? setting.min_delay_between_steps : 60;
                    
                    // Map device IDs to device objects (need to wait for devices to be loaded)
                    if (setting.device_ids && Array.isArray(setting.device_ids) && setting.device_ids.length > 0) {
                        // Ensure devices are loaded first
                        if (this.devices.length === 0) {
                            await this.loadDevices();
                        }
                        this.form.device_ids = setting.device_ids.map(id => {
                            const device = this.devices.find(d => d.id === id);
                            return device || { id: id, name: `Device ${id}`, device_id: id };
                        }).filter(d => d); // Remove any null/undefined entries
                    }
                }
            } catch (err) {
                // Settings not found, use defaults
                console.log("Settings not found, using defaults");
            }
        },
        customLabel(device) {
            return `${device.name} (${device.status})`;
        },
        clearWorkHour(which) {
            if (which === 'start') {
                this.form.work_hours_start = null;
            } else if (which === 'end') {
                this.form.work_hours_end = null;
            }
        },
        clearAllWorkHours() {
            this.form.work_hours_start = null;
            this.form.work_hours_end = null;
        },
        normalizeWorkHour(val) {
            if (val === null || val === undefined) return null;
            const s = String(val).trim();
            return s ? s : null;
        },
        async saveSettings() {
            // Convert device_ids to array if not already
            const deviceIds = this.form.device_ids && Array.isArray(this.form.device_ids)
                ? this.form.device_ids.map(device => device.id || device)
                : [];

            if (deviceIds.length === 0) {
                this.$toast.error("Pilih minimal satu device");
                return;
            }

            this.isSaving = true;
            try {
                // Helper function to convert to integer
                const toInt = (val) => {
                    if (val === true || val === 1 || val === "1") return 1;
                    if (val === false || val === 0 || val === "0" || val === null || val === undefined) return 0;
                    return parseInt(val) || 0;
                };

                // Convert device_ids to array of IDs
                const deviceIds = this.form.device_ids && Array.isArray(this.form.device_ids)
                    ? this.form.device_ids.map(device => device.id || device)
                    : [];

                // Serialize selectedDays back to "0,1,2,3,4,5,6" format
                const workDaysStr = this.selectedDays && this.selectedDays.length > 0
                    ? this.selectedDays.slice().sort((a, b) => a - b).join(',')
                    : null;

                const dataToSend = {
                    is_active: toInt(this.form.is_active),
                    timezone: this.form.timezone != null ? this.form.timezone : 7,
                    work_hours_start: this.normalizeWorkHour(this.form.work_hours_start),
                    work_hours_end: this.normalizeWorkHour(this.form.work_hours_end),
                    work_days: workDaysStr,
                    max_follow_up_per_contact: this.form.max_follow_up_per_contact != null ? this.form.max_follow_up_per_contact : 5,
                    min_delay_between_steps: this.form.min_delay_between_steps != null ? this.form.min_delay_between_steps : 60,
                    device_ids: deviceIds
                };

                await this.$store.dispatch("followup/followup_settings_update", dataToSend);
                this.$toast.success("Pengaturan berhasil disimpan");
            } catch (err) {
                this.$toast.error("Gagal menyimpan pengaturan");
            } finally {
                this.isSaving = false;
            }
        }
    }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

